<div class="checkbox">
    <label>
        <input type="checkbox" [(ngModel)]="isAllLayersSelected"
               (click)="toggleLayers()">
        <strong>{{ isAllLayersSelected ? 'Unselect All Layers' : 'Select All Layers' }}</strong>
    </label>
</div>

<div *ngIf="loading" class="loader is-active padding-leader-3 padding-trailer-3">
    <div class="loader-bars"></div>
    <div class="loader-text">Loading...</div>
</div>

<div *ngIf="mapLayers" class="canvas">
    <ul class="list-plain map-list">
        <li class="clearfix" *ngFor="let layer of mapLayers">
            <label>
                <input type="checkbox" [(ngModel)]="layer.isChecked" (change)="checkAllSelected(layer)">
               {{ layer.name }}
                <br /> <small class="text-muted description">{{ layer.description }}</small>
            </label>
        </li>
    </ul>
</div>
<div class="foot text-right">
    <label *ngIf="includeMapFilter" class="map-filter-check">
        <input type="checkbox" [(ngModel)]="includeMapFilter" />Include Filters
    </label>
    <button class="btn btn-primary" (click)="addToMap()">Add To Map</button>
    <button class="btn btn-warning" (click)="cancel()">Cancel</button>
</div>
